import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import vi from './locales/vi.json';
import en from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      vi: { translation: vi },
      en: { translation: en },
    },
    fallbackLng: 'vi',
    interpolation: {
      escapeValue: false, // React tự handle XSS
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Sync html lang attribute with current language
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
// Set initial lang
document.documentElement.lang = i18n.language || 'vi';

export default i18n;
